// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".property-select[data-v-04aa9fca]{margin-bottom:4px}.property-select__input[data-v-04aa9fca]{width:calc(100% - 34px - 34px);padding-bottom:5px}", ""]);
// Exports
module.exports = exports;
